import React from 'react';
import DataTable from 'react-data-table-component';
import { useTranslation } from 'react-i18next';

// Page-size defaults for every table in the dashboard (Trello rp6gdBL1).
// react-data-table-component has no global config, only per-table props, so
// every table goes through this wrapper instead of importing DataTable
// directly — enforced by the no-restricted-imports rule in package.json's
// eslintConfig. The library's own default is 10 rows.
export const DEFAULT_ROWS_PER_PAGE = 30;
export const ROWS_PER_PAGE_OPTIONS = [10, 15, 20, 25, 30];

// AppDataTable is react-data-table-component's DataTable with pagination on,
// 30 rows per page, and translated pagination labels. Any prop passed in
// still overrides these.
export function AppDataTable(props) {
  const { t } = useTranslation();

  const paginationComponentOptions = {
    rowsPerPageText:       t('pagination_rows_per_page'),
    rangeSeparatorText:    t('pagination_range_separator'),
    selectAllRowsItem:     false,
    selectAllRowsItemText: t('pagination_select_all'),
  };

  return (
    <DataTable
      pagination
      paginationPerPage={DEFAULT_ROWS_PER_PAGE}
      paginationRowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      paginationComponentOptions={paginationComponentOptions}
      {...props}
    />
  );
}

export default AppDataTable;
